// Chakra imports
import { Flex, Icon, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MdEdit, MdVisibility, MdDelete, MdBlock } from "react-icons/md";
import activosApi from 'api/activos';
import { isSoloLectura } from 'utils/permissions';

interface MultiActionsProps {
  id: string;
  editPath?: string;
  viewPath?: string;
  onDelete?: (id: string) => void;
  onDeactivate?: (id: string) => void;
  showDeactivate?: boolean; // Nueva prop
}

export default function MultiActions({ 
  id, 
  editPath = '/admin/main/ecommerce/page-example',
  viewPath = '/admin/main/ecommerce/page-example',
  onDelete,
  onDeactivate // recibimos la nueva función
}: MultiActionsProps) {
  const navigate = useNavigate();
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const hoverColor = useColorModeValue("brand.500", "brand.400");

  const handleEdit = () => {
    navigate(`${editPath}/${id}?mode=edit`);
  };

  const handleView = () => {
    navigate(`${viewPath}/${id}?mode=view`);
  };

  const handleDelete = async () => {
    try {
      const response = await activosApi.baja(id);
      console.log('Eliminado con éxito', response.data);
      if (onDelete) onDelete(id);
    } catch (error) {
      console.error('Error al eliminar:', error);
    }
  };

  const handleDeactivate = () => {
    if (onDeactivate) {
      onDeactivate(id);
    }
  };

  return (
    <Flex gap="10px">
      {!isSoloLectura() && (
        <Icon
          as={MdEdit}
          w="20px"
          h="20px"
          color={textColor}
          cursor="pointer"
          _hover={{ color: hoverColor }}
          onClick={handleEdit}
        />
      )}
      <Icon
        as={MdVisibility}
        w="20px"
        h="20px"
        color={textColor}
        cursor="pointer"
        _hover={{ color: hoverColor }}
        onClick={handleView}
      />
{/*       {onDelete && (
       
          <Icon
            as={MdDelete}
            w="20px"
            h="20px"
            color={textColor}
            cursor="pointer"
            _hover={{ color: hoverColor }}
            onClick={handleDelete}
          />
       
      )} */}
    </Flex>
  );
}
